<template>
  <v-dialog
    max-width="440px"
    v-model="show"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card v-if="showCard">
      <div
        class="d-flex justify-space-between"
      >
        <v-card-title>{{ title }}</v-card-title>
        <v-btn
          class="mr-1 mt-1"
          icon
          small
          @click="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider v-if="message"></v-divider>
      <v-card-text v-if="message" class="py-3">
        {{ message }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer v-if="!showDeleteBtn"></v-spacer>
        <v-btn
          small
          color="primary"
          :outlined="showDeleteBtn"
          @click="closeDialog"
        >
          {{ showDeleteBtn ? 'cancel' : 'Ok' }}
        </v-btn>
        <v-spacer v-if="showDeleteBtn"></v-spacer>
        <v-btn
          v-if="showDeleteBtn"
          small
          color="red darken-2 white--text"
          @click="deleteTask"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'AlertAboutDeleteDialog',
  data () {
    return {
      showCard: false,
      canDelete: false,
      title: '',
      message: '',
      showDeleteBtn: true
    }
  },
  computed: {
    show: {
      get () {
        const dialogData = this.$store.getters.getDeleteAlertDialogData
        if (dialogData.data.Task_ID) {
          this.checkIfCanDelete(dialogData.data)
        }
        return dialogData.show
      },
      set (val) {
        if (!val) {
          this.$store.dispatch('setAlertAboutDeleteDialogData', {
            show: val,
            data: {
              Is_Folder: null,
              Task_ID: null,
              Parent_Task_ID: null,
              Name: null
            }
          })
        }
      }
    },
    dialogData () {
      return this.$store.getters.getDeleteAlertDialogData.data
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    checkIfCanDelete (data) {
      this.axios.post('/api/check-if-can-delete-task', data, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.canDelete = res.data[0].Can_Delete
        this.title = `Delete ${this.dialogData.Is_Folder ? 'folder' : 'task'}`
        if (this.canDelete) {
          this.message = `Are you sure you want to delete '${this.dialogData.Name}' ${this.dialogData.Is_Folder ? 'folder' : 'task'}?`
        } else {
          if (this.dialogData.Is_Folder) {
            this.showDeleteBtn = false
            this.message = 'You can\'t delete this folder because there are child tasks or folders.'
          } else {
            this.message = 'Current task has reports. If you delete this task, reports will be deleted as well. Are you sure?'
          }
        }
        this.showCard = true
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    deleteTask () {
      const projectId = this.dialogData.Project_ID
      this.axios.delete(`/api/tasks/${this.dialogData.Task_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: `${this.dialogData.Is_Folder ? 'Folder' : 'Task'} successfully deleted!` })
        this.$store.dispatch('updateReportsList', { update: true })
        this.$emit('updateTasks', projectId)
        this.closeDialog()
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    closeDialog () {
      this.show = false
      this.resetDialogData()
    },
    resetDialogData () {
      this.showCard = false
      this.canDelete = false
      this.title = ''
      this.message = ''
      this.showDeleteBtn = true
    }
  }
}
</script>
